<div class="page-head">
  <div>
    <h1>Products</h1>
    <div class="sub">The marketplace catalog and seller product changes awaiting review</div>
  </div>
</div>

<div class="page-body">
  <div class="tabs">
    <button
      type="button"
      class="tab"
      [class.active]="activeTab === 'catalog'"
      (click)="activeTab = 'catalog'">
      Marketplace catalog
    </button>
    <button *staffCan="'Marketplace.ProductChanges.Moderate'"
      type="button"
      class="tab"
      [class.active]="activeTab === 'pending'"
      (click)="activeTab = 'pending'">
      Pending changes
    </button>
  </div>

  @if (activeTab === 'catalog') {
    <app-marketplace-catalog></app-marketplace-catalog>
  } @else {
    <app-pending-product-changes *staffCan="'Marketplace.ProductChanges.Moderate'"></app-pending-product-changes>
  }
</div>
